/**
 * Shared narrative helpers — the presented-prose rendering pieces reused by the
 * extraction review AND the Kompass profile surface (rather than copied). Splits a
 * markdown narrative body into simple heading/paragraph blocks (no markdown lib) and
 * localises the authored-on date.
 */

export interface NarrativeBlock {
  heading: boolean
  text: string
}

/** Split narrative markdown into heading vs paragraph blocks. */
export function narrativeBlocks(body: string): NarrativeBlock[] {
  return body
    .split(/\n{2,}/)
    .map((raw) => raw.trim())
    .filter((b) => b.length > 0)
    .map((b) => (b.startsWith("#") ? { heading: true, text: b.replace(/^#+\s*/, "") } : { heading: false, text: b }))
}

/** Localise an ISO authoring timestamp to a German long date, or null. */
export function authoredOnDate(authoredAt: string | null): string | null {
  return authoredAt !== null
    ? new Intl.DateTimeFormat("de-DE", { day: "numeric", month: "long", year: "numeric" }).format(new Date(authoredAt))
    : null
}
